import { f as n } from "../../vendor--aJiswR_.js";
import "react/jsx-runtime";
import "react";
import { getSpacingClasses as y } from "../../utils/getSpacingClasses/index.js";
import '../../assets/index28.css';const a = "_baseButton_1rkmy_1", d = "_sm_1rkmy_35", i = "_md_1rkmy_40", p = "_primary_1rkmy_45", u = "_secondary_1rkmy_58", k = "_ghost_1rkmy_59", g = "_destructive_1rkmy_85", t = {
  baseButton: a,
  sm: d,
  md: i,
  primary: p,
  secondary: u,
  ghost: k,
  destructive: g
}, h = ({
  size: s,
  variant: o,
  m: r,
  mt: m,
  mr: _,
  mb: c,
  ml: e
}) => n(
  t.baseButton,
  s ? t[s] : void 0,
  o ? t[o] : void 0,
  y({ m: r, mt: m, mr: _, mb: c, ml: e })
);
export {
  h as getButtonStyles
};
//# sourceMappingURL=index.js.map
